<script setup lang="ts">
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';

interface Props {
  saveDisabled?: boolean;
  deleteDisabled?: boolean;
  editing: boolean;
  showSave?: boolean;
}

withDefaults(defineProps<Props>(), {
  showSave: true,
  deleteDisabled: false,
  saveDisabled: false,
});

const emit = defineEmits(['saved', 'editing', 'deleted']);
</script>

<template>
  <div
    class="tw-flex group-hover:tw-visible tw-items-center tw-justify-end tw-space-x-2"
    :class="editing ? 'tw-flex' : 'tw-invisible'"
  >
    <div
      v-if="editing"
      class="tw-flex tw-space-x-2"
    >
      <button
        type="button"
        title="Save"
        v-if="showSave"
        :disabled="saveDisabled"
        class="tw-border-none tw-outline-none tw-text-connx-success"
        aria-label="Save"
        @click="emit('saved')"
      >
        <connx-icon
          name="fas fa-check"
          class="tw-w-auto tw-h-[14px] tw-text-connx-success"
        ></connx-icon>
      </button>
      <button
        type="button"
        title="Cancel Edit"
        class="tw-border-none tw-outline-none"
        aria-label="Cancel Edit"
        @click="emit('editing', false)"
      >
        <connx-icon
          name="fas fa-times"
          class="tw-h-[15px] tw-w-auto tw-text-connx-grey"
        ></connx-icon>
      </button>
    </div>
    <button
      v-else
      type="button"
      title="Edit"
      class="tw-border-none tw-outline-none tw-text-connx-success"
      aria-label="Edit"
      @click="emit('editing', true)"
    >
      <connx-icon
        name="fas fa-pen"
        class="tw-w-auto tw-h-[14px] tw-text-connx-primary"
      ></connx-icon>
    </button>
    <button
      type="button"
      :title="deleteDisabled ? 'Delete is Disabled' : 'Delete'"
      :disabled="deleteDisabled"
      :class="{
        'tw-text-connx-danger': !deleteDisabled,
        'tw-text-connx-grey-tint-50': deleteDisabled,
      }"
      class="tw-border-none tw-outline-none group-hover:tw-opacity-1"
      :aria-label="deleteDisabled ? 'Delete is Disabled' : 'Delete'"
      @click="deleteDisabled ? null : emit('deleted')"
    >
      <connx-icon
        name="far fa-trash-alt"
        class="tw-w-auto tw-h-[14px]"
      ></connx-icon>
    </button>
  </div>
</template>
